import * as types from './constants';

// Settings
export const getSettingsRequest = () => (
  { type: types.GET_SETTINGS_REQUEST }
);

export const getSettingsDone = data => (
  { type: types.GET_SETTINGS_DONE, payload: data }
);

export const getSettingsFailed = errors => (
  { type: types.GET_SETTINGS_FAILED, payload: errors }
);